module.exports = __webpack_public_path__ + "img/user-icon.37a4eaf0.svg";